/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSpecsGridStyles = makeStyles(theme => ({
  root: {
    width: 'auto',
    minWidth: '100%',
    borderRadius: '6px',
    background: '#F6F7F8',
  },
  container: {
    display: 'flex',
    margin: '0 -10px',
    flexWrap: 'wrap',
    padding: '15px',
  },
  spec: {
    padding: '5px 10px',
    minWidth: '120px',
  },
  specName: {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
  },
  specValue: {
    marginTop: '8px',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '24px',
  },
}));
